import { isBuhBillUnpaidForSuspend } from './buhBillPayment';

export const BUH_SUSPEND_TOOLTIP = 'Обслуживание приостановлено';

function parseDateOnly(value) {
    if (value == null || value === '') return null;
    const s = String(value).trim().replace('T', ' ').slice(0, 10);
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
}

function isBuhSuspendCancelActive(untilRaw) {
    const until = parseDateOnly(untilRaw);
    if (!until) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return until >= today;
}

function suspendFlagInt(client, key) {
    const v = Number(client?.[key]);
    return Number.isFinite(v) ? v : 0;
}

function resolveSuspendMode(client) {
    if (!client) return 'auto';
    if (isBuhSuspendCancelActive(client.buh_suspend_cancel_until)) return 'cancel';
    const auto = suspendFlagInt(client, 'buh_auto_suspend_unpaid');
    const manual = suspendFlagInt(client, 'buh_manual_suspend');
    if (auto === 1 && manual === 1) return 'manual';
    if (auto === 1 && manual === 0) return 'auto';
    // legacy auto=0 — режим auto; cancel только при активном buh_suspend_cancel_until
    return 'auto';
}

function countMainUnpaid(packs) {
    return (packs || []).filter((pack) => isBuhBillUnpaidForSuspend(pack)).length;
}

export function enrichClientWithUnpaidCount(client, packs) {
    const count = client?.buh_unpaid_main_count != null
        ? Number(client.buh_unpaid_main_count) || 0
        : countMainUnpaid(packs);
    return { ...client, buh_unpaid_main_count: count };
}

export function clientBuhServiceSuspended(client) {
    if (!client) return false;
    if (isBuhSuspendCancelActive(client.buh_suspend_cancel_until)) return false;
    const mode = resolveSuspendMode(client);
    if (mode === 'manual') return true;
    if (mode !== 'auto') return false;
    const count = Number(client.buh_unpaid_main_count) || 0;
    return count >= 2;
}

export function resolveClientProfile(rawUser) {
    if (!rawUser) return null;
    if (Array.isArray(rawUser.user)) return rawUser.user[0] || null;
    if (rawUser.user && typeof rawUser.user === 'object') return rawUser.user;
    return rawUser;
}
